import { useContent } from "../../../../../../../contexts/contentContext/contentContext";
import { ButtonA } from "../../../../../../Elements/Button/Button";
import Image from "../../../../../../Elements/Image/Image";

import styles from "./styles.module.scss";

const PAYPAL_URL = "https://www.paypal.com/myaccount/wallet/";

const PayPalPaymentSection = () => {
  const { getTextByKey } = useContent();

  return (
    <div className={styles.paypalDetailsWrapper}>
      <h2 className={styles.title}>{getTextByKey("payment-details-title")}</h2>
      <div className={styles.paypalDataWrapper}>
        <Image name="paypal-logo" ext="jpg" alt="paypal" title="PayPal" />
        <span>{getTextByKey("payment-paypal-text")}</span>
        <div className={styles.buttons}>
          {/*@ts-ignore*/}
          <ButtonA href={PAYPAL_URL} target="_blank" rel="noopener noreferrer">
            {getTextByKey("payment-paypal-btn")}
          </ButtonA>
        </div>
      </div>
    </div>
  );
};

export default PayPalPaymentSection;
